import { usePlaybackCurrentTs, usePlaybackSeekInRange } from '@app/core/playback/hooks/usePlayback';
import { toTimestamp } from '@mi-front/core';
import { ClickableGraphArea, Marker } from '@mi-front/ui';
import { lighten } from 'polished';
import { PlayheadP } from '../../../../../../../logger/screens/stream/components/focus/playhead/Playhead';
import { DisplayableChunk } from '../../../../../../types';

interface ChunkMarkersProps {
  chunk: DisplayableChunk;
}

/**
 * Displays markers on the chunk waveform.
 * Includes the start marker, clickable seek area, and playhead.
 */
export function ChunkMarkers({ chunk }: ChunkMarkersProps) {
  const currentTs = usePlaybackCurrentTs();
  const seek = usePlaybackSeekInRange();

  return (
    <>
      <Marker ts={toTimestamp(chunk.from)!} color={lighten(0.1, chunk.color)} />
      <ClickableGraphArea
        onTsClick={(ts) => {
          seek(ts);
        }}
        showHoverCursor
      />
      {!!currentTs && <PlayheadP ts={currentTs} />}
    </>
  );
}
